import * as React from 'react'
import ReactGA from 'react-ga4'

import { buildAdminUrl, buildJoinQueryString, buildJoinUrl } from '../../../../commons/utils'
import Button from '../../atoms/Button/Button'
import QRCode from '../../atoms/QRCode/QRCode'
import Switch from '../../atoms/Switch/Switch'
import CopyableLabel from '../../molecules/CopyableLabel/CopyableLabel'
import * as styles from './EditorQuizURLModalItem.css'

interface EditorQuizURLModalProps {
  shareParam: string
  isAcceptParticipant: boolean
  handleChangeAccept: (input: boolean) => void
  handleClickOpenPresentationWindow: () => void
  handleDownloadRankingData: () => void
  isFetchableRankingData: boolean
}

const EditorQuizURLModal: React.FunctionComponent<EditorQuizURLModalProps> = ({
  shareParam,
  isAcceptParticipant,
  handleChangeAccept,
  handleClickOpenPresentationWindow,
  handleDownloadRankingData,
  isFetchableRankingData
}) => {
  const quizStartUrl = buildAdminUrl('/presentation')
  const participantUrl = buildJoinUrl(
    `?${buildJoinQueryString({
      share_param: shareParam
    })}`
  )

  const openPrepareQuizWindow = () => {
    ReactGA.event({
      label: 'show-quiz',
      category: 'button',
      action: 'click'
    })
    handleClickOpenPresentationWindow()
  }

  const openControllerWindow = () => {
    window.open('controller', 'controller', 'width=700,height=150')
  }

  const openParticipantWindow = () => {
    window.open(participantUrl, 'participant', 'width=400,height=700')
  }

  const downloadQRCode = () => {
    const canvas: any = document.querySelector('#participant-qrcode-download>canvas')
    if (canvas) {
      const url = canvas.toDataURL('image/png')
      const link = document.createElement('a')
      link.href = url
      link.download = 'qrcode.png'
      link.click()
    }
  }

  const handleClickDownloadRankingDataButton = () => {
    ReactGA.event({
      label: 'download-ranking-data',
      category: 'button',
      action: 'click'
    })
    handleDownloadRankingData()
  }

  return (
    <div className={styles.container}>
      <div className={styles.join}>
        <p className={styles.title}>1. 参加者にURLを配る</p>
        <div className={styles.body}>
          <div className={styles.url}>
            <CopyableLabel label={participantUrl} />
          </div>
          <div className={styles.right}>
            <div className={styles.blueButton}>
              <Button handleClick={() => openParticipantWindow()}>
                <p className={styles.buttonText}>ページを開く</p>
              </Button>
            </div>
            <div className={styles.qrPart}>
              <div className={styles.qrCode} onClick={() => downloadQRCode()}>
                <QRCode url={participantUrl} size={80} />
                <p className={styles.downloadText}>ダウンロード</p>
              </div>
            </div>
          </div>
        </div>

        <div id="participant-qrcode-download" className={styles.download}>
          <QRCode url={participantUrl} size={500} />
        </div>
      </div>

      <div className={styles.quiz}>
        <p className={styles.title}>2. クイズのスライドを表示する</p>
        <div className={styles.body}>
          <div className={styles.url}>
            <CopyableLabel label={quizStartUrl} />
          </div>
          <div className={styles.right}>
            <div className={styles.blueButton} style={{ marginBottom: '20px' }}>
              <Button handleClick={() => openPrepareQuizWindow()}>
                <p className={styles.buttonText}>ページを開く</p>
              </Button>
            </div>
            <div className={styles.blueButton}>
              <Button handleClick={() => openControllerWindow()}>
                <p className={styles.buttonText}>操作パネル</p>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.start}>
        <p className={styles.title}>3. 参加者の登録受付を開始する</p>
        <div className={styles.row}>
          <p className={styles.desc}>
            ONにするまで参加者には待機画面が表示されます
            <br />
            本番より前にURLを配布する場合はOFFにしてください
          </p>
          <div className={styles.switchButton}>
            <Switch checked={isAcceptParticipant} handleChange={handleChangeAccept} />
          </div>
        </div>
      </div>

      <div className={styles.start}>
        <p className={styles.title}>4. ランキングデータをダウンロードする</p>
        <div className={styles.row}>
          <p className={styles.downloadDesc}>クイズ後にランキングデータをcsv形式でダウンロードできます</p>
          <div className={styles.downloadButton}>
            <Button isEnabled={isFetchableRankingData} handleClick={() => handleClickDownloadRankingDataButton()}>
              <p className={styles.buttonText}>ダウンロード</p>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditorQuizURLModal
